<template>
    <div class="addBox relative">
      <div class="title">
        <div class="title_left">
          <span class="movePoin" @click="$router.go(-1)">来源管理</span>/<span class="type">详情</span>
        </div>
      </div>
      <el-form :model="supplyEntityForm" ref="supplyEntityForm" label-width="150px">
        <ToggleForm title="基本信息">
          <div class="content">
            <div class="row mt20">
              <el-form-item label="所在区域：" prop="areaCode">
                {{supplyEntityForm.name}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="所在区域：" prop="areaCode">
                {{supplyEntityForm.areaName}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="经营地址：" prop="addr">
                {{supplyEntityForm.addr}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="法人/负责人：" prop="legalPerson">
                {{supplyEntityForm.legalPerson}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="联系方式：" prop="tel">
                {{supplyEntityForm.tel}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="身份证号：">
                {{supplyEntityForm.idCard}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="上传证照：">
                <div class="pzUploadBox">
                  <img @click="ifbig(supplyEntityForm.creditLicenseFileId)" v-if="supplyEntityForm.creditLicenseFileId"
                       :src="supplyEntityForm.creditLicenseFileId" class="imgInfo">
                  <img @click="ifbig(supplyEntityForm.licenceFileId)" v-if="supplyEntityForm.licenceFileId"
                       :src="supplyEntityForm.licenceFileId" class="imgInfo">
                </div>
                <p class="imgTipP">
                  <span v-if="supplyEntityForm.creditLicenseFileId">营业执照</span>
                  <span v-if="supplyEntityForm.licenceFileId">食品经营许可证</span>
                </p>
              </el-form-item>
            </div>
          </div>
        </ToggleForm>
      </el-form>
      <div class="foot-btn">
        <div>
          <el-button class="w70 mr10" @click="$router.go(-1)">返回</el-button>
          <el-button type="primary w70" @click="openEdit">编辑</el-button>
        </div>
      </div>
      <div class='big-img relative' v-show="showBigPic" @click.stop="showBigPic=false">
        <img :src="bigImgSrc">
      </div>
    </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import * as api from "api/report";
export default {
  name: "personAdd",
  components: { 
      ToggleForm,
  },
  data() {
    return {
      showBigPic: false,
      bigImgSrc: '',
      id: '',
      type: '',
      supplyEntityForm: {
        addr: '', //经营地址
        areaCode: '',  //区域code
        areaName: '',  //区域名称
        creditCode: '',  //统一社会信用代码
        creditLicenseFileId: '', //营业执照
        id: '', //来源id编辑必填, 
        idCard: '',  //身份证
        legalPerson: '', //法人
        licenceFileId: '', //许可证
        name: '',  //来源名称
        tel: '' //联系方式
      },
      entityLists: [],
      animalVoucherList: [],
      tranVoucherList: [],
      baseUrl: this.$store.state.common.baseUrl,
      btn: false,
    };
  },
  methods: {
    ifbig(src){
      this.bigImgSrc = src;
      this.showBigPic = true;
    },
    openEdit() {
      this.$router.push({ name: 'sourceFill.sourceFillAdd', query: { type: 'edit', id: this.id } })
    },
    initEditData() {
      api.entityGet({id: this.$route.query.id}).then(r=>{
        if(r.code == 200){
          this.supplyEntityForm = r.data;
          if(r.data.creditLicenseFile.length>0){
            this.supplyEntityForm.creditLicenseFileId = this.baseUrl + '/' + r.data.creditLicenseFile[0].fileId;
          } else {
            this.supplyEntityForm.creditLicenseFileId = '';
          } 
          if(r.data.licenceFile.length>0){
            this.supplyEntityForm.licenceFileId = this.baseUrl + '/' + r.data.licenceFile[0].fileId;
          } else {
            this.supplyEntityForm.licenceFileId = '';
          }
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id ? this.$route.query.id : "";
    this.initEditData()
  }
};
</script>

<style scoped lang='scss'>
.addBox {
  width: calc(100% - 40px);
  min-height: calc(100% - 100px);
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
  .content{
    padding: 0 30px;
    .tabLab{
      width: 180px;
      display: block;
      text-align: center;
    }
  }
}
.margin-10{
  margin-left: -10px;
}
.w80{
  width: 80px;
}
.w140{
  width: 140px;
}
.pinzheng_span{
  font-size: 14px;
  color: #70CE97;
  cursor: pointer;
}
.w70{
  width: 70px;
}
.pzUploadBox{
  overflow: hidden;
  .ybUpload,.imgInfo{
    width: 100px;
    height: 100px;
    overflow: hidden;
    float: left;
    margin-right: 25px;
  }
  .ybUpload:last-child{
    margin-right: 0;
  }
}
.imgTipP{
  color: #666;
  font-style: 14px;
  padding: 10px 0;
  line-height: 20px;
  span{
    display: inline-block;
    width: 100px;
    margin-right: 30px;
    text-align: center;
  }
  span:last-child{
    margin-right: 0;
  }
}
.big-img {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  >img {
    display: block;
    max-height: 700px;
  }
}
</style>